export default {
  changelogs: {
    date_deploy: 'Date: {{period}}',
    enhancement: 'Enhancements',
    fix: 'Fixes',
    new_feature: 'New Features',
    title: 'Changelogs'
  }
};
